import { FormValidator } from "@syncfusion/ej2-inputs";
import * as React from "react";
import { useCallback } from "react";
import Editor from "@monaco-editor/react";
import * as ReactDOM from "react-dom";
import {
  TextBoxComponent,
  NumericTextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";
import {
  MultiSelectComponent,
  CheckBoxSelection,
  Inject,
} from "@syncfusion/ej2-react-dropdowns";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { useNavigate } from "react-router-dom";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import {
  DataManager,
  Query,
  WebApiAdaptor,
  WebMethodAdaptor,
} from "@syncfusion/ej2-data";
import {
  getCookie,
  convertObjToArray,
  convertArrayToObj,
  testRestApi,
  testJS,
  getToken,
  getUserInfo,
  saveFlowField,
  ExportToExcel,
  getTranslateValue,
  extractValuesFromBrackets,
  calculateRows,
} from "../../utils/Functions";
import ApiClient from "../../api/ApiClient";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { InPlaceEditorComponent } from "@syncfusion/ej2-react-inplace-editor";
import {
  CheckBoxComponent,
  RadioButtonComponent,
  ButtonComponent,
} from "@syncfusion/ej2-react-buttons";

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Filter,
  Sort,
  Edit,
  Resize,
  Toolbar,
  Aggregate,
  Page,
  DetailRow,
  ExcelExport,
} from "@syncfusion/ej2-react-grids";

import Typography from "../customdesign/Typography";
import CompFormFileManager from "./CompFormFileManager";
import CompFormDesinger from "./CompFormDesinger";
import CompFilterDesinger from "./CompFilterDesinger";

import CompDashboardDesinger from "./CompDashboardDesinger";

import CompFormOption from "./CompFormOption";
import CompFormAction from "./CompFormAction";
import CompFormCompValues from "./CompFormCompValues";

import CompFormValue from "./CompFormValue";

import CompFormInput from "./CompFormInput";
import CompFormOptionChart from "./CompFormOptionChart";
import CompFormOptionGrid from "./CompFormOptionGrid";
import CompGroupedPermission from "./CompGroupedPermission";
import CompFlowTaskPicker from "./CompFlowTaskPicker";
import Loading from "../customdesign/Loading";

function JsEditorField({ name, label, value, onChange, disabled, language = "javascript", height = 280 }) {
  const [isDark, setIsDark] = React.useState(
    document.documentElement.getAttribute("data-theme") === "dark"
  );
  React.useEffect(() => {
    const obs = new MutationObserver(() => {
      setIsDark(document.documentElement.getAttribute("data-theme") === "dark");
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);

  return (
    <div style={{ border: "1px solid var(--xflow-line, #d0d7de)", borderRadius: 4, overflow: "hidden" }}>
      <div style={{
        padding: "4px 10px",
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: isDark ? "#4a6180" : "#8a8d91",
        background: isDark ? "#0d1525" : "#f6f8fa",
        borderBottom: `1px solid ${isDark ? "#1e2d47" : "#d0d7de"}`,
        userSelect: "none",
      }}>
        {label}
      </div>
      <Editor
        height={height}
        defaultLanguage={language}
        value={value || ""}
        theme={isDark ? "vs-dark" : "light"}
        options={{
          readOnly: disabled,
          domReadOnly: disabled,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          fontSize: 13,
          lineNumbers: "on",
          wordWrap: "on",
          automaticLayout: true,
          tabSize: 2,
        }}
        onChange={(val) => onChange({ target: { name, value: val ?? "" } })}
      />
    </div>
  );
}

export var specialComponents = {};

// Actualiza el valor de widgets Syncfusion ya montados (select/daterange/date)
// directo por su instancia, sin pasar por props de React. GenericForm nunca
// vuelve a leer `data` despues del mount (no tiene componentDidUpdate), y
// forzar un remount (key/unmount) destruye+recrea el <DialogComponent> que
// envuelve el formulario — eso dispara un bug conocido de Syncfusion
// ("insertBefore ... is not a child of this node" en Dialog.setIsModal) al
// reinicializarlo. Setear las propiedades del widget vivo + dataBind() evita
// el remount por completo. Usado por el boton "Resetear Filtros" de Report.js.
export function resetFieldsValue(fieldsMap) {
  Object.keys(fieldsMap || {}).forEach((name) => {
    let comp = specialComponents[name];
    if (!comp) return;
    let val = fieldsMap[name];
    try {
      if (Array.isArray(val) && "startDate" in comp) {
        if (comp.setProperties) {
          comp.setProperties({ startDate: val[0], endDate: val[1] });
        } else {
          comp.startDate = val[0];
          comp.endDate = val[1];
          if (comp.dataBind) comp.dataBind();
        }
      } else if ("value" in comp) {
        // Un DropDownList vacio no limpia el texto mostrado con
        // setProperties({value:""}) porque "" no matchea ningun item del
        // dataSource — EJ2 lo trata como valor invalido y deja el ultimo
        // seleccionado. clear() es el metodo dedicado para esto.
        if ((val === "" || val === null || val === undefined) && comp.clear) {
          comp.clear();
        } else if (comp.setProperties) {
          comp.setProperties({ value: val });
        } else {
          comp.value = val;
          if (comp.dataBind) comp.dataBind();
        }
      }
    } catch (e) {
      console.log("resetFieldsValue error", name, e);
    }
  });
}
var dialogInstanceMessage;
const customerData = {};
var textObj;
const clientWidth = window.innerWidth;
const BASE_URL = process.env.REACT_APP_API_CONFIG;

const Input = ({
  label,
  name,
  value,
  floatBlur,
  floatFocus,
  onChange,
  type,
  saveFlowFieldLocal,
  defConfig,
  defLang,
  ..._rest
}) => {
  //console.log(name, _rest)
  const navigate = useNavigate();
  const [remoteOptions, setRemoteOptions] = React.useState([]);
  const [remoteLoading, setRemoteLoading] = React.useState(false);
  var values = [];
  var text = "";
  var checkFields = { text: "Name", value: "Code" };
  var groupFields = { text: "Name", value: "Code", groupBy: "Groupcondition" };
  let remoteFields, query;

  let rest = _rest;
  if (_rest.values?.datatype) {
    if (rest.values.datatype == "static") {
      rest["values"] = rest.values.options;
    } else {
      rest["apiurl"] = rest.values.apiurl;
      rest["apidata"] = rest.values.apidata;
      rest["apimethod"] = rest.values.apimethod;
      rest["apitoken"] = rest.values.apitoken;
      rest["fields"] = { text: rest.values.text, value: rest.values.value };
    }
  }
  const simpleRemoteSelect = !!(rest.apiurl && (!rest.apidata || rest.apidata === ""));

  if (rest.apiurl) {
    remoteFields = rest.fields; // Example{ text: 'FLOWGROUP', value: 'FLOWGROUPID' };
    if (!simpleRemoteSelect) {
      // Filtered dynamic selects (apidata present) keep the Syncfusion DataManager
      // binding below, unchanged.
      var token = getCookie(process.env.REACT_APP_NAME + "_usertoken");
      if (rest.apitoken) {
        if (rest.apitoken !== "" && rest.apitoken !== "NOTOKEN") {
          token = rest.apitoken;
        }
      }
      let url = rest.apiurl;
      if (rest.apiurl.indexOf("http") < 0) {
        url = process.env.REACT_APP_API_CONFIG + rest.apiurl;
      }
      customerData[name] = new DataManager({
        url: url,
        adaptor:
          rest.apimethod === "post"
            ? new WebMethodAdaptor()
            : new WebApiAdaptor(),
        headers: [
          { Authorization: "Bearer " + token },
          { getInfo: "simplified" },
        ],
        crossDomain: true,
      });

      let apidata = extractValuesFromBrackets(rest.apidata, rest.formDataObj);
      query = new Query()
        .addParams("$apidata", apidata)
        .select([rest.fields.text, rest.fields.value])
        .take(1000)
        .requiresCount();
    }
  }

  // Plain axios fetch for unfiltered dynamic selects (flow name, status, etc).
  // Avoids Syncfusion's DataManager/WebMethodAdaptor entirely — no custom
  // "getInfo" header, no OData-style body wrapping the backend doesn't expect.
  const remoteApiUrl = simpleRemoteSelect ? rest.apiurl : null;
  const remoteApiToken = rest.apitoken;
  const remoteFieldText = simpleRemoteSelect ? rest.fields?.text : null;
  const remoteFieldValue = simpleRemoteSelect ? rest.fields?.value : null;

  React.useEffect(() => {
    if (!remoteApiUrl) return;
    let cancelled = false;
    (async () => {
      setRemoteLoading(true);
      try {
        let url = remoteApiUrl;
        if (url.indexOf("http") < 0) {
          url = process.env.REACT_APP_API_CONFIG + url;
        }
        let tok = getCookie(process.env.REACT_APP_NAME + "_usertoken");
        if (remoteApiToken && remoteApiToken !== "" && remoteApiToken !== "NOTOKEN") {
          tok = remoteApiToken;
        }
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + tok,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });
        const json = await response.json();
        const rows = json?.result || json?.data || [];
        if (!cancelled) {
          setRemoteOptions(
            rows.map((row) => ({
              Code: row[remoteFieldValue],
              Name: row[remoteFieldText],
            }))
          );
        }
      } catch (e) {
        if (!cancelled) setRemoteOptions([]);
      } finally {
        if (!cancelled) setRemoteLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [remoteApiUrl, remoteApiToken, remoteFieldText, remoteFieldValue]);

  try {
    if (type !== "space") {
      if (
        rest.values &&
        (type === "select" ||
          type === "options" ||
          type === "optionsGrid" ||
          type === "optionsChart" ||
          type === "radio" ||
          type === "multiple" ||
          type === "autocomplete" ||
          type === "multiple")
      ) {
        if (rest.values[0]) {
          let keys = Object.keys(rest.values[0]);
          rest.values.map((key, index) => {
            if (key["GROUPCONDITION"]) {
              values.push({
                Code: key[keys[0]], //.toString(),
                Name: getTranslateValue(key[keys[1]]) || key[keys[1]],
                Groupcondition: key["GROUPCONDITION"],
              });
            } else {
              values.push({
                Code: key[keys[0]], //.toString(),
                Name: getTranslateValue(key[keys[1]]) || key[keys[1]],
              });
            }

            if (key[keys[0]] == value) {
              text = key[keys[1]];
            }
          });

          if (!Array.isArray(value)) {
            if (value == "" && rest.values[0]) {
              value = rest.values[0][keys[0]];
            }
          }
        }
      }
    }
  } catch (e) {
    console.log(">>>>err:", name, value, type, e);
  }
  switch (type) {
    case "title":
      return <Typography variant={rest?.variant}>{label}</Typography>;

    case "text":
      if (!rest.disabled && rest.editOnline && rest.wfpflowid) {
        return (
          <>
            <span
              className={
                "e-float-text-edit" +
                (rest?.priority && rest.priority === "YES"
                  ? " input-highlight"
                  : "")
              }
            >
              {label}{" "}
            </span>
            <InPlaceEditorComponent
              actionSuccess={(e) => saveFlowFieldLocal(name, e.value)}
              id={name}
              mode="Popup"
              type="Text"
              value={value === undefined ? "" : value}
              model={{ placeholder: "Update " + label }}
              popupSettings={{ title: "Update " + label }}
              cssClass={
                rest?.priority && rest.priority === "YES"
                  ? " input-highlight"
                  : ""
              }
            ></InPlaceEditorComponent>
          </>
        );
      } else {
        return (
          <>
            <TextBoxComponent
              id={name}
              onFocus={floatFocus}
              onBlur={floatBlur}
              readonly={rest?.readonly}
              data-msg-containerid={name + "Error"}
              disabled={rest?.disabled}
              name={name}
              placeholder={label}
              value={value == "undefined" ? "" : value}
              onChange={({ value }) => onChange({ target: { name, value } })}
              htmlAttributes={{ autocomplete: 'off' }}
              cssClass={
                (rest?.className ? rest.className : "e-outline") +
                (rest.invalid ? " e-error" : "") +
                (rest?.priority && rest.priority === "YES"
                  ? " input-highlight"
                  : "")
              }
              floatLabelType="Auto"
            />
            {rest.invalid &&
              rest.invalid_message &&
              rest.invalid_message !== "" && (
                <span className="validation-message e-error">
                  {" "}
                  {rest.invalid_message}{" "}
                </span>
              )}
          </>
        );
      }
    case "date":
      return (
        <div className="custom-datepicker-container">
          <span className="cspan">{label}</span>
          <div>
            <DateTimePickerComponent
              name={name}
              onChange={(event) => {
                onChange({
                  target: { name: name, value: event.value, type: "date" },
                });
              }}
              format={"dd/MM/yyyy HH:mm"}
              value={value}
              cssClass={" e-error custom-datepicker"}
            />
            {rest.formValidation?.findIndex((item) => item.name === name) >=
              0 && (
              <label
                style={{ position: "relative", top: -10 }}
                className="e-error"
              >
                {
                  rest.formValidation[
                    rest.formValidation.findIndex((item) => item.name === name)
                  ].message
                }
              </label>
            )}
          </div>
        </div>
      );

    case "button":
      return (
        <ButtonComponent
          key={"btn" + name}
          className="e-success"
          id={"formBTN___" + name}
          name={"formBTN___" + name}
        >
          {label}
        </ButtonComponent>
      );

    case "daterange":
      return (
        <DateRangePickerComponent
          onChange={(event) => {
            onChange({
              target: { name: name, value: event.value, type: "date" },
            });
          }}
          startDate={value[0]}
          endDate={value[1]}
          format="dd/MMM/yy hh:mm a"
          ref={(scope) => {
            specialComponents[name] = scope;
          }}
        ></DateRangePickerComponent>
      );
    case "values":
      return (
        <div className="my-1 e-card e-custom-card">
          <span className="comp-label"> {label} </span>
          <CompFormValue
            value={value}
            ref={(scope) => {
              specialComponents[name] = scope;
            }}
            type={type}
            name={name}
            label={label}
            onChange={onChange}
          />
        </div>
      );
    case "options":
      return (
        <CompFormOption
          value={value}
          ref={(scope) => {
            specialComponents[name] = scope;
          }}
          type={type}
          name={name}
          label={label}
          onChange={onChange}
        />
      );
    case "optionsGrid":
      return (
        <CompFormOptionGrid
          value={value}
          ref={(scope) => {
            specialComponents[name] = scope;
          }}
          type={type}
          name={name}
          label={label}
          onChange={onChange}
        />
      );
    case "actions":
      return (
        <div className="my-1 e-card e-custom-card">
          <span className="comp-label"> {label} </span>
          <CompFormAction
            value={value}
            ref={(scope) => {
              specialComponents[name] = scope;
            }}
            type={type}
            name={name}
            label={label}
            onChange={onChange}
          />
        </div>
      );
    case "componentvalues":
      return (
        <div className="my-1 e-card e-custom-card">
          <span className="comp-label"> {label} </span>
          <CompFormCompValues
            value={value}
            ref={(scope) => {
              specialComponents[name] = scope;
            }}
            type={type}
            name={name}
            label={label}
            onChange={onChange}
          />
        </div>
      );
    case "inputs":
      return (
        <div className="my-1 e-card e-custom-card">
          <span className="comp-label"> {label} </span>
          <CompFormInput
            value={value}
            ref={(scope) => {
              specialComponents[name] = scope;
            }}
            type={type}
            name={name}
            label={label}
            onChange={onChange}
          />
        </div>
      );
    case "optionsChart":
      return (
        <CompFormOptionChart
          value={value}
          ref={(scope) => {
            specialComponents[name] = scope;
          }}
          type={type}
          name={name}
          label={label}
          onChange={onChange}
        />
      );

    case "select":
      //console.log("rest", rest, query);
      if (simpleRemoteSelect) {
        return (
          <>
            <DropDownListComponent
              dataSource={remoteOptions}
              ref={(scope) => {
                specialComponents[name] = scope;
              }}
              fields={checkFields}
              name={name}
              value={value != "" ? value : undefined}
              cssClass={
                (rest?.className ? rest.className : "e-outline") +
                (rest.formValidation?.findIndex((item) => item.name === name) >=
                0
                  ? " e-error"
                  : "")
              }
              placeholder={remoteLoading ? "Cargando..." : label}
              floatLabelType="Auto"
              enabled={rest.enabled}
              select={({ itemData }) => {
                onChange({ target: { name, value: itemData.Code } });
              }}
            />
            {rest.formValidation?.findIndex((item) => item.name === name) >=
              0 && (
              <label
                style={{ position: "relative", top: -10 }}
                className="e-error"
              >
                {
                  rest.formValidation[
                    rest.formValidation.findIndex((item) => item.name === name)
                  ].message
                }
              </label>
            )}
          </>
        );
      } else if (rest.apiurl) {
        if (value != "") {
          return (
            <>
              <DropDownListComponent
                dataSource={customerData[name]}
                ref={(scope) => {
                  specialComponents[name] = scope;
                }}
                query={query}
                fields={remoteFields}
                name={name}
                value={value}
                cssClass={
                  (rest?.className ? rest.className : "e-outline") +
                  (rest.formValidation?.findIndex(
                    (item) => item.name === name
                  ) >= 0
                    ? " e-error"
                    : "")
                }
                placeholder={label}
                floatLabelType="Auto"
                enabled={rest.enabled}
                select={({ itemData }) => {
                  let value = itemData.Code;
                  if (!itemData.Code) {
                    value = itemData[remoteFields.value];
                  }
                  onChange({ target: { name, value: value, rest: itemData } });
                }}
              />
              {rest.formValidation?.findIndex((item) => item.name === name) >=
                0 && (
                <label
                  style={{ position: "relative", top: -10 }}
                  className="e-error"
                >
                  {
                    rest.formValidation[
                      rest.formValidation.findIndex(
                        (item) => item.name === name
                      )
                    ].message
                  }
                </label>
              )}
            </>
          );
        } else {
          return (
            <>
              <DropDownListComponent
                dataSource={customerData[name]}
                ref={(scope) => {
                  specialComponents[name] = scope;
                }}
                query={query}
                fields={remoteFields}
                name={name}
                cssClass={
                  (rest?.className ? rest.className : "e-outline") +
                  (rest.formValidation?.findIndex(
                    (item) => item.name === name
                  ) >= 0
                    ? " e-error"
                    : "")
                }
                placeholder={label}
                floatLabelType="Auto"
                enabled={rest.enabled}
                select={({ itemData }) => {
                  let value = itemData.Code;
                  if (!itemData.Code) {
                    value = itemData[remoteFields.value];
                  }
                  onChange({ target: { name, value: value, rest: itemData } });
                }}
              />
              {rest.formValidation?.findIndex((item) => item.name === name) >=
                0 && (
                <label
                  style={{ position: "relative", top: -10 }}
                  className="e-error"
                >
                  {
                    rest.formValidation[
                      rest.formValidation.findIndex(
                        (item) => item.name === name
                      )
                    ].message
                  }
                </label>
              )}
            </>
          );
        }
      } else {
        return (
          <>
            <DropDownListComponent
              dataSource={values}
              ref={(scope) => {
                specialComponents[name] = scope;
              }}
              name={name}
              value={value}
              fields={checkFields}
              enabled={rest.enabled}
              cssClass={
                (rest?.className ? rest.className : "e-outline") +
                (rest.formValidation?.findIndex((item) => item.name === name) >=
                0
                  ? " e-error"
                  : "")
              }
              placeholder={label}
              floatLabelType="Auto"
              select={({ itemData }) => {
                onChange({ target: { name, value: itemData.Code } });
              }}
            />
            {rest.formValidation?.findIndex((item) => item.name === name) >=
              0 && (
              <label
                style={{ position: "relative", top: -10 }}
                className="e-error"
              >
                {
                  rest.formValidation[
                    rest.formValidation.findIndex((item) => item.name === name)
                  ].message
                }
              </label>
            )}
          </>
        );
      }

    case "scriptarea":
      return (
        <TextBoxComponent
          id={name}
          onFocus={floatFocus}
          onBlur={floatBlur}
          data-msg-containerid={name + "Error"}
          disabled={rest?.disabled}
          name={name}
          multiline={true}
          placeholder={label}
          value={value}
          onChange={({ value }) => onChange({ target: { name, value } })}
          htmlAttributes={{ autocomplete: 'off' }}
          cssClass={
            (rest?.className ? rest.className : "e-outline") +
            (rest.invalid ? " e-error" : "") +
            (rest?.priority && rest.priority === "YES"
              ? " input-highlight"
              : "")
          }
          floatLabelType="Auto"
        />
      );

    case "jseditor":
      return <JsEditorField name={name} label={label} value={value} onChange={onChange} disabled={rest?.disabled} />;
    case "sqleditor":
      // Mismo editor Monaco que "jseditor" (ya sigue el tema claro/oscuro de
      // la app) pero en modo SQL — para el campo "Component" del panel de
      // Dashboard, donde normalmente se escribe un SELECT largo y un input
      // de una sola línea no sirve (ver Utils.dashboardPanelEditor).
      return <JsEditorField name={name} label={label} value={value} onChange={onChange} disabled={rest?.disabled} language="sql" height={220} />;
    case "switch":
      return (
        <div
          disabled={rest?.disabled}
          style={{
            display: "flex",
            alignItems: "center",
            height: 31,
          }}
        >
          <label
            htmlFor={name}
            style={{
              padding: "0px 0px 0px 0",
              marginBottom: 0,
              fontWeight: "normal",
            }}
          >
            {" "}
            {label}
          </label>
          <SwitchComponent
            cssClass="bar-color"
            id={name}
            name={name}
            onChange={({ value }) =>
              onChange({
                target: { name, value: value ? value : "", type: "switch" },
              })
            }
            checked={value === "YES"}
          ></SwitchComponent>
        </div>
      );

    case "numeric":
      let min = rest.min || 0;
      let max = rest.max || 9999999999;
      return (
        <>
          <NumericTextBoxComponent
            name={name}
            min={min}
            max={max}
            disabled={rest?.disabled}
            format={rest.format ? rest.format : "N2"}
            value={value}
            floatLabelType="Auto"
            onChange={({ value }) => onChange({ target: { name, value } })}
            cssClass={
              (rest?.className ? rest.className : "e-outline") +
              (rest.formValidation?.findIndex((item) => item.name === name) >= 0
                ? " e-error"
                : "")
            }
            placeholder={label}
          />
          {rest.formValidation?.findIndex((item) => item.name === name) >=
            0 && (
            <label
              style={{ position: "relative", top: -10 }}
              className="e-error"
            >
              {
                rest.formValidation[
                  rest.formValidation.findIndex((item) => item.name === name)
                ].message
              }
            </label>
          )}
        </>
      );
    case "textarea":
      return (
        <>
          <TextBoxComponent
            onFocus={floatFocus}
            onBlur={floatBlur}
            disabled={rest?.disabled}
            data-msg-containerid={name + "Error"}
            multiline={true}
            readonly={rest?.readonly}
            rows={rest?.rows || 2}
            placeholder={label}
            value={value}
            cssClass={
              (rest?.className ? rest.className : "e-outline") +
              (rest.invalid ? " e-error" : "")
            }
            onChange={({ value }) => onChange({ target: { name, value } })}
            htmlAttributes={{ autocomplete: 'off' }}
            floatLabelType="Auto"
          />
          {rest.invalid &&
            rest.invalid_message &&
            rest.invalid_message !== "" && (
              <span className="validation-message-extended e-error">
                {" "}
                {rest.invalid_message}{" "}
              </span>
            )}
        </>
      );

    case "password":
      return (
        <>
          <TextBoxComponent
            id={name}
            disabled={rest?.disabled}
            onFocus={floatFocus}
            onBlur={floatBlur}
            data-msg-containerid={name + "Error"}
            name={name}
            type="password"
            placeholder={label}
            value={value}
            onChange={({ value }) => onChange({ target: { name, value } })}
            htmlAttributes={{ autocomplete: 'new-password' }}
            cssClass={
              (rest?.className ? rest.className : "e-outline") +
              (rest.invalid ? " e-error" : "")
            }
            floatLabelType="Auto"
          />
          {rest.invalid &&
            rest.invalid_message &&
            rest.invalid_message !== "" && (
              <span className="validation-message e-error">
                {" "}
                {rest.invalid_message}{" "}
              </span>
            )}
        </>
      );

    case "link":
      return (
        <div
          style={rest.style ? rest.style : {}}
          className="item-link"
          onClick={() => {
            navigate(value);
          }}
        >
          {label}
        </div>
      );

    case "radio":
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 41,
            borderBottom: "1px solid #c2c2c2",
          }}
        >
          <span className="field-form-label"> {label} </span>
          {rest?.values.map((e) => (
            <span className="ml-1">
              <RadioButtonComponent
                key={e}
                disabled={rest?.disabled}
                label={e.text}
                value={e.value}
                className="mr-1"
                name={name}
                onChange={({ value }) =>
                  onChange({ target: { name, value: e.value } })
                }
                checked={value === e.value}
              />
            </span>
          ))}
        </div>
      );

    case "multiple":
      return (
        <CompGroupedPermission
          name={name}
          label={label}
          values={values}
          value={value || []}
          onChange={onChange}
        />
      );

    case "hidden":
      return <input type="hidden" name={name} value={value ?? ""} onChange={onChange} />;

    case "flowtaskpicker":
      return (
        <CompFlowTaskPicker
          name={name}
          label={label}
          value={value}
          onChange={onChange}
        />
      );

    case "dropdown":
      return (
        <DropDownListComponent
          dataSource={rest?.options}
          name={name}
          disabled={rest?.disabled}
          select={({ itemData }) => {
            onChange({ target: { name, value: itemData.value } });
          }}
          value={value}
        />
      );
    case "componentformcontainer":
      return (
        <CompFormDesinger
          type={type}
          name={name}
          label={label}
          onChange={onChange}
          value={value}
          defConfig={defConfig}
          defLang={defLang}
        />
      );
    case "file":
      return (
        <CompFormFileManager
          type={type}
          name={name}
          label={label}
          onChange={onChange}
          value={value}
          defConfig={defConfig}
          defLang={defLang}
          rest={_rest}
        />
      );
    case "componentfiltercontainer":
      return (
        <CompFilterDesinger
          type={type}
          name={name}
          label={label}
          onChange={onChange}
          value={value}
        />
      );

    case "componentdashboardcontainer":
      return (
        <CompDashboardDesinger
          type={type}
          name={name}
          label={label}
          onChange={onChange}
          value={value}
        />
      );

    case "checkbox":
      return (
        <CheckBoxComponent
          label={rest?.checkboxLabel}
          disabled={rest?.disabled}
          name={name}
          onChange={(e) =>
            onChange({ target: { name, value: e.target.checked } })
          }
          checked={value}
        />
      );
    case "space":
      /*return(
				<div class="form-group">
					<div class="e-float-input e-control-wrapper">
						<div style={{  height: "0px" }}></div>
						
					</div>
				</div>
			)*/
      return (
        <div className="" style={{ height: rest.size.lg == 12 ? 0 : 50 }}></div>
      );

    case "autocomplete":
      return (
        <ComboBoxComponent
          ref={(scope) => {
            specialComponents[name] = scope;
          }}
          ignoreAccent={true}
          allowFiltering={true}
          name={name}
          cssClass={"e-custom-combobox"}
          floatLabelType="auto"
          value={value.toString()}
          fields={checkFields}
          dataSource={values}
          placeholder={label}
        />
        /**
								<MultiSelectComponent  ref={(scope) => { specialComponents[name] = scope; }} dataSource={values}
									fields={checkFields} placeholder={label} mode="CheckBox" 
									showSelectAll={true}
									value={value.toString()}
									showDropDownIcon={true} 
									filterBarPlaceholder={label} popupHeight="350px">
									<Inject services={[CheckBoxSelection]} />
								</MultiSelectComponent>
								 */
      );

    case "image":
      return <input type="hidden" name={name} value={value.toString()} />;
    case "grid":
      return (
        <GridComponent
          dataSource={value}
          allowPaging={true}
          allowResizing={true}
          allowFiltering={true}
          filterSettings={{ type: "Excel" }}
          allowSorting={true}
          allowExcelExport={true}
          ref={(scope) => {
            specialComponents[name] = scope;
          }}
          allowEditing={rest.isEditable} // Usa el estado para permitir o deshabilitar la edición
          editSettings={{
            allowEditing: rest.allowEditing,
            allowAdding: rest.allowAdding,
            allowDeleting: rest.allowDeleting,
            mode: "Inline",
          }}
          toolbar={
            rest.isEditable ? ["Add", "Edit", "Delete", "Update", "Cancel"] : []
          }
          actionComplete={(args) => {
            if (args.requestType === "save") {
              let obj = {
                type: "grid",
                name: name,
                value: specialComponents[name].dataSource,
              };
              onChange({ target: obj });
            }
          }}
        >
          <ColumnsDirective>
            {rest.columns &&
              rest.columns.map((col, index) => (
                <ColumnDirective
                  key={index}
                  field={col.field}
                  headerText={col.headerText}
                  width={col.width}
                  textAlign={col.textAlign || ""}
                  isPrimaryKey={col.isPrimaryKey || false}
                  isReadOnly={col.readonly}
                  format={col.format || ""}
                />
              ))}
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Resize,
              Sort,
              DetailRow,
              ExcelExport,
              Page,
            ]}
          />
        </GridComponent>
      );

    default:
      return "no:" + type;
  }
};

class GenericForm extends React.Component {
  constructor(props) {
    super(props);
    this.animationSettings = { effect: "Fade" };
    this.state = {
      formValues: {},
      buttons: [],
      originalformInputs: [],
      events: [],
      loading: false,
      apiResponseMessage: "init",
      //showResponse:false,
      expandStatus: false,
      wWidth: window.innerWidth,
      varSchema: [],
    };
  }

  floatFocus(args) {
    args.target.parentElement.classList.add("e-input-focus");
  }
  floatBlur(args) {
    args.target.parentElement.classList.remove("e-input-focus");
  }

  onOverlayClick() {
    this.dialogInstance.hide();
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.checkEnter);
    document.removeEventListener("click", this.checkClick);
    this.setState({ ...this.state, events: [] });
  }

  setRefreshingData(status) {
    this.setState({ ...this.state, loading: status });
  }
  async componentDidMount() {
    // initialize the form rules
    //console.log("GEN", this.props)
    if (this.props.wfpflowid && this.props.wfptaskid && this.props.officecode) {
      //console.log("w" , window.innerWidth )
      this.setState({
        ...this.state,
        wWidth: window.innerWidth,
        wfpflowid: this.props.wfpflowid,
        wfptaskid: this.props.wfptaskid,
        officecode: this.props.officecode,
      });
    }

    if (this.props.varSchema) {
      this.setState({ ...this.state, varSchema: this.props.varSchema });
    }

    await this.prepareForm(
      this.props.data,
      this.props.buttons,
      this.props.wfpflowid,
      this.props.wfptaskid,
      this.props.officecode,
      this.props.datapostload
    );

    document.removeEventListener("click", this.checkClick);
    document.removeEventListener("keyup", this.checkEnter);
    document.addEventListener("click", this.checkClick);
    document.addEventListener("keyup", this.checkEnter);

    let events = [];
    this.props.data.map((key, index) => {
      if (key.addbutton) {
        if (Array.isArray(key.addbutton)) {
          key.addbutton.map((keyB) => {
            events.push(keyB);
          });
        } else {
          events.push(key.addbutton);
        }
      }
    });
    if (this.props.expandaction) {
      events.push({
        id: "expandOption",
        open: this.props.expandaction,
        close: this.props.collapseaction,
      });
    }
    //console.log("events", events)
    this.setState({ ...this.state, events: events });
  }

  checkEnter = async (event) => {
    if (event.key === "Enter" && event.target.id) {
      if (this.state.formValues[event.target.id]) {
        if (this.state.buttons.length === 1) {
          let formValues = this.state.formValues;
          try {
            let keys = Object.keys(specialComponents);
            Object.keys(specialComponents).map((key, index) => {
              let field = specialComponents[key];
              formValues[key] = field.value;
            });
          } catch (e) {
            //console.log("no custom data", specialComponents, e)
          }

          this.state.buttons[0].action(formValues);
        }
      }
    }
  };

  /* Abre el iframe de la tarea en una pestaña nueva. Se invoca directo desde el
     onClick del botón (no depende del listener global checkClick ni de
     offsetParent.name, que era frágil y a veces abría about:blank). Pestaña
     nueva (no popup dimensionado) → el navegador no la bloquea al venir de un
     click del usuario, y se ve mejor. */
  openExternalIframe = (url) => {
    if (!url) return;
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (win) win.opener = null;
  };

  checkClick = async (event) => {
    let elem = event.target;
    /* SVG elements return SVGAnimatedString for className — normalize to plain string */
    const cn = typeof elem.className === "string" ? elem.className : "";

    if (cn.indexOf("e-open-link") >= 0) {
      elem["id"] = "openiFrame";
    }

    if (cn && elem.id) {
      let id = elem.id;

      if (id.indexOf("formBTN___") >= 0) {
        try {
          let formData = this.state.originalformInputs;
          let pos = formData.findIndex(
            (item) => item.name === id.replace("formBTN___", "")
          );
          if (pos >= 0) {
            let formValues = this.state.formValues;
            let action = formData[pos].action;
            const { ExportToExcel } = require("../../utils/Functions");
            //await eval(action);
            await eval(" (async () => {" + action + "})();");

            //ExportToExcel( formData, formValues , "taskForm")
          }
        } catch (Ex) {
          console.log(">>>>Error:", Ex);
        }
      } else {
        if (id === "" && cn.indexOf("e-icons") >= 0) {
          id = elem.offsetParent.id;
        }

        let name = elem.name;
        if (id === "openiFrame" && cn.indexOf("e-icons") >= 0) {
          name = elem.offsetParent.name;
        }

        if (cn.indexOf("e-open-link") >= 0) {
          id = "openiFrame";
        }

        var appUrl = process.env.REACT_APP_URL_CONFIG;
        const pos = this.state.events.findIndex((item) => item.id === id);
        let expandStatus = this.state.expandStatus;

        if (id === "openiFrame") {
          window.open(
            elem.name,
            "Execute Task",
            "width=760, height=550, scrollbars=NO"
          );
          this.setState({ ...this.state, loading: false });
        } else {
          if (pos >= 0) {
            let eventField = this.state.events[pos];
            //predefined functions
            let fieldName = event.target.name;

            this.setState({
              ...this.state,
              loading: true /*showResponse:false*/,
            });
            if (id == "refresh") {
              let formData = convertArrayToObj(this.state.originalformInputs);

              if (formData[fieldName].api) {
                var apidata = {};
                var _apidata = formData[fieldName].apidefdata.split(",");
                for (let d in _apidata) {
                  let info = _apidata[d].split("=");
                  apidata[info[0]] = info[1];
                }
                let value = "";
                let values = await ApiClient.getCustomData(
                  formData[fieldName].api,
                  apidata
                );
                if (values.length > 0) {
                  var fields = Object.keys(values[0]);
                  values.map(function (key, item) {
                    key["value"] = key[fields[0]];
                    key["text"] = key[fields[1]];
                  });
                  if (formData[fieldName].type.indexOf("autocomplete") < 0) {
                    value = values[0][fields[0]];
                  }
                }

                formData[fieldName].values = values;
                formData[fieldName].originalvalues = values;
                formData[fieldName].value = value;
                //console.log(formData[fieldName])
              }
              let formInputs = convertObjToArray(formData, "layout_row");

              this.setState({ ...this.state, formInputs: [], loading: false });

              setTimeout(
                async function () {
                  await this.prepareForm(
                    formInputs,
                    this.state.buttons,
                    this.state.wfpflowid,
                    this.state.wfptaskid,
                    this.state.officecode
                  );
                }.bind(this),
                50
              );

              //	this.setState({  ...this.state })
            } else if (id == "testapi") {
              let formData = convertArrayToObj(this.state.formValues);
              let response = {};
              if (formData.processtypeid == "54") {
                response = await testRestApi(formData);
              } else if (formData.processtypeid == "55") {
                response = await testJS(formData);
              } else {
                response = { status: false, message: "not implemented" };
              }

              dialogInstanceMessage.show();
              this.setState({
                ...this.state,
                loading: false,
                expandStatus: expandStatus,
                apiResponseMessage: JSON.stringify(response),
              });
            } else if (id == "expandOption") {
              //				console.log("expandimos", this.state.events[pos])

              if (!this.state.expandStatus) {
                this.state.events[pos].open();
              } else {
                this.state.events[pos].close();
              }
              expandStatus = !this.state.expandStatus;
              this.setState({
                ...this.state,
                loading: false,
                expandStatus: expandStatus,
              });
            } else {
              if (eventField.action) {
                try {
                  const { simpleGetData } = require("../../utils/Functions");
                  const { simplePostData } = require("../../utils/Functions");
                  const utils = require("../../utils/Utils");
                  if (
                    eventField.action.indexOf("async") >= 0 ||
                    eventField.action.indexOf("await") >= 0
                  ) {
                    setRefreshingData(true);
                    //await eval(eventField.action);
                    await eval(" (async () => {" + eventField.action + "})();");
                    setRefreshingData(false);
                  } else {
                    //console.log("sync",  eventField.action )
                    eval(eventField.action);
                  }
                } catch (Exc) {
                  window.alert("error exec custom code");
                  //console.log("ERROR", Exc, eventField.action)
                }
              }
              this.setState({ ...this.state, loading: false });
            }
          }
        }
      }
    }
  };

  saveFlowFieldLocal = (name, value) => {
    saveFlowField(this.props.wfpflowid, this.props.wfptaskid, name, value);
    if (this.props.onChangeForm) {
      this.props.onChangeForm(
        this.props.wfpflowid,
        this.props.wfptaskid,
        name,
        value
      );
    }
  };

  prepareForm = async (
    preFormData,
    buttons,
    wfpflowid,
    wfptaskid,
    officecode,
    datapostload
  ) => {
    //console.log("thi", this.state, this.props)
    let options = {
      rules: {},
    };
    let formValues = {};
    this.setState({
      ...this.state,
      loading: true,
      originalformInputs: [],
      formInputs: [],
    });
    let formButtons = [];
    const now = new Date();
    const defDate = Math.floor(now.getTime() / 1000);
    if (buttons) {
      formButtons = this.props.buttons.map((b, index) => {
        return (
          <div
            className={
              (b.size ? b.size : "col-xs-12 col-md-6 col-lg-4 col-xl-3") +
              " min-padding "
            }
          >
            <ButtonComponent
              key={"btn" + index}
              className={
                (this.props.buttons.length > 1 ? "mr-10" : "") +
                " " +
                (b.className ? b.className : "e-success")
              }
              id={b.name}
              name={b.name}
              onClick={this.onSubmitClick.bind(this)}
              style={
                b.style
                  ? b.style
                  : { textTransform: "uppercase", fontWeight: "500" }
              }
            >
              {b.label ? b.label : defConfig[defLang].savedatalabel}
            </ButtonComponent>
          </div>
        );
      });
    }
    preFormData.sort(function (a, b) {
      return b.layout_row > a.layout_row
        ? -1
        : b.layout_row < a.layout_row
        ? 1
        : 0;
    });
    let formData = convertArrayToObj(preFormData);
    let formDataObj = {};
    let aditionalData = {};

    if (this.props.aditionalFlowData) {
      aditionalData = convertArrayToObj(this.props.aditionalFlowData);
    }

    for (let i in preFormData) {
      formDataObj[preFormData[i].name] = {
        name: preFormData[i].name,
        value: preFormData[i].value,
        label: preFormData[i].label,
      };
    }
    //console.log("formData:::", formDataObj);

    if (datapostload) {
      //console.log(datapostload)
      //console.log("********************INJECTED CODE*********************")

      try {
        const { simpleGetData } = require("../../utils/Functions");
        const { simplePostData } = require("../../utils/Functions");
        const utils = require("../../utils/Utils");

        if (
          datapostload.indexOf("async") >= 0 ||
          datapostload.indexOf("await") >= 0
        ) {
          //console.log("async",  )
          this.setRefreshingData(true);
          //await eval(datapostload);
          await eval(" (async () => {" + datapostload + "})();");

          //console.log("fin")
          this.setRefreshingData(false);
        } else {
          //console.log("sync");

          eval(datapostload);
        }
      } catch (Exc) {
        window.alert("error compiling field action");
        console.log("ERROR", Exc, datapostload);
      }
      //console.log("********************INJECTED CODE*********************")
    }

    formData = convertObjToArray(formData, "layout_row");

    if (this.props.varSchema) {
      let varSchema = this.props.varSchema;
      formData.map(function (e, item) {
        let pos = varSchema.findIndex((item) => item.VARNAME === e.name);
        if (pos >= 0) {
          e["priority"] = varSchema[pos].REMARKABLE;
        } else {
          e["priority"] = "NO";
        }
      });
    }

    let formInputs = formData.map((_e, index) => {
      //let _e = formData[key]
      let editOnline = false;
      let disabled = false;
      if (this.props.varSchema) {
        if (this.props.varSchema.length > 0) {
          disabled = true;
          editOnline = true;
        }
      }
      if (this.props.varSchema) {
        let pos = this.props.varSchema.findIndex(
          (item) => item.VARNAME === _e.name
        );
        if (pos > 0) {
          let option = this.props.varSchema[pos].EDITABLE;
          if (option === "NO") {
            disabled = true;
          } else if (option === "ALL") {
            disabled = false;
          } else {
            if (
              option === getUserInfo().USERGROUP ||
              getUserInfo().USERGROUPID === 1
            ) {
              disabled = false;
            } else {
              disabled = true;
            }
          }
        }
      }
      let enabled = !disabled;
      let e;
      if (_e.forceDiabled) {
        disabled = true;
        enabled = false;
      }

      if (_e.name?.indexOf("comment_") >= 0 && _e.value?.length > 0) {
        _e["type"] = "textarea";
        _e["label"] = _e["label"].toUpperCase();
        _e["expand"] = true; //CHECKING
        _e["readonly"] = true;
        _e["layout_sizeX"] = 12;
        _e["size"] = { xs: 12, lg: 12 };
        let result = calculateRows(
          _e.value,
          clientWidth > 799 ? clientWidth * 0.35 : clientWidth - 100
        );
        _e["rows"] = result;
        disabled = false;
        enabled = true;
        editOnline = false;
      }

      if (_e.name === "postloadscript" || _e.name === "preloadscript") {
        _e["type"] = "jseditor";
        _e["layout_sizeX"] = 12;
        _e["size"] = { xs: 12, lg: 12 };
      }

      if (_e.layout_id) {
        e = _e;
        e["rules"] = {};
        e["value"] = _e.value ? _e.value : "";
        e["values"] = _e.values ? _e.values : [];
        e["size"] = { xs: 12, lg: _e.layout_sizeX };
        e["enabled"] = enabled;
        e["disabled"] = disabled;
        e["editOnline"] = editOnline;
        e["format"] = _e.format || "###";
        e["checkboxLabel"] = "";
        e["className"] = "";
        e["formValidation"] = this.props.formValidation;
        e["varSchema"] = this.props.varSchema;
        e["wfpflowid"] = wfpflowid;
        e["wfptaskid"] = wfptaskid;
        e["priority"] = _e.priority;
        e["formDataObj"] = formDataObj;
      } else {
        e = _e;
        e["formValidation"] = this.props.formValidation;
        e["varSchema"] = this.props.varSchema;
        e["disabled"] = disabled;
        e["enabled"] = enabled;
        e["editOnline"] = editOnline;
        e["wfpflowid"] = wfpflowid;
        e["wfptaskid"] = wfptaskid;
        e["priority"] = _e.priority;
        e["formDataObj"] = formDataObj;
      }

      let { rules, label, name, value, type, addbutton } = e;
      //define rules for input field
      let formattedRules = {
        required: [true, "* Field Required"],
      };
      if (e.rules) {
        options.rules[name] = formattedRules;
      }
      formValues[name] = value ? value : "";
      let xs = 12;
      let lg = 12;
      if (e.size?.xs) {
        xs = e.size.xs;
      }
      if (e.size?.lg) {
        lg = e.size.lg;
      }

      let addPath = "";
      if (type === "iframe") {
        addPath =
          "?wfpflowid=" +
          wfpflowid +
          "&wfptaskid=" +
          wfptaskid +
          "&officecode=" +
          officecode;

        if (e.iframetype === "EXTERNAL") {
          // options siempre viaja (aunque vacío) para que el iframe externo
          // nunca haga params.get("options").split(",") sobre null. Cuando
          // la tarea no está asignada al usuario (VIEW → flowactions=[]),
          // además se manda locked=true para que la app externa bloquee
          // toda acción (ver DialogExecuteTask/CompTreeGridV2 value==="VIEW").
          const locked = this.props.flowactions.length === 0;
          addPath +=
            "&options=" +
            this.props.flowactions.toString() +
            (locked ? "&locked=true" : "");
        }

        addPath += "&token=" + getToken();
      }

      if (type === "hidden") {
        if (this.props.onChange) {
          if (typeof value !== "object") {
            this.props.onChange({
              target: {
                name: name,
                value: value ? value.toString() : _e.defaultvalue || "",
              },
            });
          }
        }
      }

      if (type === "file") {
        console.log("e", _e);
        if (!_e.defaultvalue) {
          console.log("llenamos");
          _e["defaultvalue"] = defDate.toString();
        }
      }
      //      console.log("e",_e,e)
      return type === "iframe" ? (
        <div className="xflow-iframe-field">
          {e.iframetype && !this.props.noExternalButon && (
            <div className="xflow-iframe-toolbar">
              <button
                type="button"
                className="xflow-iframe-external-btn"
                title={
                  (this.props.defConfig &&
                    this.props.defConfig[this.props.defLang] &&
                    this.props.defConfig[this.props.defLang].openexternallabel) ||
                  "Abrir en una ventana nueva"
                }
                onClick={(ev) => {
                  ev.stopPropagation();
                  this.openExternalIframe(e.path + addPath + "&popup=true" + (document.documentElement.getAttribute("data-theme") === "dark" ? "&darkmode=true" : ""));
                }}
              >
                <span className="e-icons e-open-link"></span>
                <span className="xflow-iframe-external-label">
                  {(this.props.defConfig &&
                    this.props.defConfig[this.props.defLang] &&
                    this.props.defConfig[this.props.defLang].openexternallabel) ||
                    "Abrir en ventana"}
                </span>
              </button>
            </div>
          )}
          <iframe
            title="task-iframe"
            width="100%"
            style={{ border: "0", display: "block", minHeight: 560 }}
            height={
              this.props.iFrameHeight
                ? this.props.iFrameHeight
                : Math.max(
                    560,
                    (typeof window !== "undefined" ? window.innerHeight : 900) -
                      170
                  )
            }
            src={e.path + addPath + (document.documentElement.getAttribute("data-theme") === "dark" ? (addPath.includes("?") ? "&" : "?") + "darkmode=true" : "")}
            allow="camera; microphone; geolocation; fullscreen; autoplay"
            allowFullScreen
          />
        </div>
      ) : type === "hidden" ? (
        <input
          type="hidden"
          name={name}
          value={value ? value.toString() : _e.defaultvalue || ""}
        />
      ) : (
        <div
          key={"field" + index}
          className={"padding-1 col-form col-xs-" + xs + " col-lg-" + lg}
        >
          <div
            key={"div" + index}
            className={
              (type == "space" && lg == 12
                ? ""
                : !e.disabled && e.editOnline
                ? "form-group-edit"
                : type === "radio"
                ? ""
                : "form-group") +
              (addbutton ? "  " : "") +
              (type === "scriptarea" ||
              name === "postloadscript" ||
              name === "preloadscript" ||
              name === "apidata" ||
              name === "apidata"
                ? " source-code"
                : "")
            }
          >
            {!addbutton ? (
              <Input
                key={"input" + index}
                name={name}
                value={value}
                type={type}
                label={label}
                floatFocus={this.floatFocus}
                floatBlur={this.floatBlur}
                onChange={this.onChange}
                saveFlowFieldLocal={this.saveFlowFieldLocal}
                defConfig={this.props.defConfig}
                defLang={this.props.defLang}
                {...e}
              />
            ) : (
              <>
                <Input
                  key={"input" + index}
                  name={name}
                  value={value}
                  type={type}
                  label={label}
                  floatFocus={this.floatFocus}
                  floatBlur={this.floatBlur}
                  onChange={this.onChange}
                  saveFlowFieldLocal={this.saveFlowFieldLocal}
                  {...e}
                />
                {type !== "space" && (
                  <>
                    {Array.isArray(addbutton) ? (
                      <div style={{ textAlign: "right" }}>
                        {addbutton.map((keyB, indexB) => {
                          return (
                            <ButtonComponent
                              style={{ textTransform: "none", marginLeft: 2 }}
                              key={"btnadd" + index + "_" + indexB}
                              iconCss={
                                keyB.id === "refresh" ? "e-icons e-refresh" : ""
                              }
                              className={
                                "e-btn " +
                                (keyB.id === "refresh"
                                  ? "  e-primary"
                                  : " e-success")
                              }
                              id={keyB.id}
                              name={name}
                            >
                              {keyB.id === "refresh" ? "" : keyB.label}
                            </ButtonComponent>
                          );
                        })}
                      </div>
                    ) : (
                      <ButtonComponent
                        key={"btnadd" + index}
                        className="ml-10 e-success"
                        id={addbutton.id}
                        name={name}
                      >
                        {addbutton.label}
                      </ButtonComponent>
                    )}
                  </>
                )}
              </>
            )}
            <div key={"error" + index} id={name + "Error"} />
          </div>
        </div>
      );
    });

    this.formObject = new FormValidator("#form1", options);
    this.formObject.customPlacement = function (element, errorElement) {
      element.parentNode.parentNode.appendChild(errorElement);
    };

    this.setState({
      ...this.state,
      loading: false,
      formButtons: formButtons,
      originalformInputs: formData,
      formInputs: formInputs,
      formValues: formValues,
      buttons: buttons,
    });
  };

  //form updating fields
  onChange = async (event) => {
    //console.log("eve", event);
    var action = "";
    const formValues = this.state.formValues;
    var formInputs = this.state.originalformInputs;
    var field = {};

    if (event.target.type) {
      if (event.target.type === "switch") {
        if (
          formValues[event.target.name] === "" ||
          formValues[event.target.name] === "NO"
        ) {
          formValues[event.target.name] = "YES";
          event["target"]["value"] = "YES";
        } else {
          formValues[event.target.name] = "";
          event["target"]["value"] = "";
        }
      } else if (event.target.type === "options") {
        let data = event.target;
        let value = {};
        if (data.datatype == "static") {
          value = {
            datatype: data.datatype,
            options: data.options,
          };
        } else {
          value = {
            datatype: data.datatype,
            apidata: data.apidata,
            apimethod: data.apimethod,
            apitoken: data.apitoken,
            apiurl: data.apiurl,
            text: data.text,
            value: data.value,
          };
        }
        //console.log( "formValues:",formValues, value)
        formValues[event.target.name] = value;
      } else if (event.target.type === "optionsGrid") {
        let data = event.target;
        let value = {};
        if (data.datatype == "static") {
          value = {
            datatype: data.datatype,
            options: data.options,
          };
        } else {
          value = {
            datatype: data.datatype,
            apidata: data.apidata,
            apimethod: data.apimethod,
            apitoken: data.apitoken,
            apiurl: data.apiurl,
            text: data.text,
            value: data.value,
          };
        }
        console.log("formValues:", value);
        formValues[event.target.name] = value;
      }
    } else {
      formValues[event.target.name] = event.target.value;
    }

    try {
      const index = formInputs.findIndex(
        (item) => item.name === event.target.name
      );

      let aditionalData = {};
      if (this.props.aditionalFlowData) {
        aditionalData = convertArrayToObj(this.props.aditionalFlowData);
      }

      if (formInputs[index].action) {
        //console.log("action", formInputs[index].action)
        if (formInputs[index].action != "") {
          const formData = convertArrayToObj(this.state.originalformInputs);
          var appUrl = process.env.REACT_APP_URL_CONFIG;
          field = formInputs[index];
          field["value"] = event.target.value;
          //console.log("formInputs", formInputs )
          //console.log("field", field )
          action = formInputs[index].action;
          const { simpleGetData } = require("../../utils/Functions");
          const {
            simplePostData,
            getCookie,
            setCookie,
          } = require("../../utils/Functions");
          const utils = require("../../utils/Utils");
          var token = getCookie(process.env.REACT_APP_NAME + "_usertoken");
          if (action.indexOf("async") >= 0 || action.indexOf("await") >= 0) {
            //console.log("async")
            this.setRefreshingData(true);
            //await eval(action);
            await eval(" (async () => {" + action + "})();");

            //console.log("fin")
            this.setRefreshingData(false);
          } else {
            //console.log("sync",action)
            eval(action);
          }
          //console.log("///////formData", formData);
          formInputs = convertObjToArray(formData, "layout_row");
          //console.log("formInputs", formInputs);
          //console.log("formValues", formValues);

          Object.keys(formValues).map((key, index) => {
            if (key !== event.target.name) {
              if (formValues[key]) {
                if (formData[key]) {
                  formData[key].value = formValues[key];
                }
                let fInput = formInputs.find((input) => input.name === key);
                if (fInput) {
                  fInput["value"] = formValues[key];
                }
              }
            }
          });

          await this.prepareForm(
            formInputs,
            this.state.buttons,
            this.state.wfpflowid,
            this.state.wfptaskid,
            this.state.officecode
          );
        }
        if (this.props.setformValues) {
          console.log("values..", this.state.formValues);
          this.props.setformValues(this.state.formValues);
        }
        if (this.props.onChange) {
          let formValues = this.state.formValues;
          Object.keys(formValues).map((key, index) => {
            if (key !== event.target.name) {
              let event = { target: { name: key, value: formValues[key] } };
              this.props.onChange(event);
            }
          });
        }
      }
      if (event.target.value && event.target.type === "grid") {
        //grid???
        event.target["value"] = this.state.formValues[event.target.name];
      }

      if (this.props.onChange) {
        this.props.onChange(event);
      }
    } catch (Exc) {
      console.log(">>>>Err", Exc);
      console.log("event", event);
      if (action != "") {
        console.log("action", action);
      }
    }
  };

  onSubmitClick(event) {
    //event.preventDefault();

    let formValues = this.state.formValues;
    const index = this.state.buttons.findIndex(
      (item) => item.name === event.target.name
    );

    //console.log(this.state.buttons, index)

    try {
      let keys = Object.keys(specialComponents);
      Object.keys(specialComponents).map((key, index) => {
        let field = specialComponents[key];
        formValues[key] = field.value;
      });
    } catch (e) {
      //console.log("no custom data", specialComponents, e)
    }

    this.state.buttons[index].action(formValues);

    /*
		  const index = this.state.buttons.findIndex((item) => item.name === event.target.name);
		  //if (this.formObject.validate()) {
			const resp =	(values)=> this.state.buttons[index].action(values) 
	  	
		  try{
			  let keys = Object.keys(specialComponents)
			  let formValues = this.state.formValues
			  Object.keys(specialComponents).map(( key, index) => {
			  	
				  let field = specialComponents[ key]
				  formValues[key] = field.value
			  	
			  });
		  }catch(e){
			  console.log("no custom data", specialComponents, e)
		  }
  
			resp( this.state.formValues);*/
  }

  render() {
    return (
      <>
        {this.state.loading && <Loading />}
        <div className="control-panel">
          <div className="row no-padding">
            <div
              className={
                "no-padding col-sm-1" +
                (this.props.expandaction ? 1 : 2) +
                " col-lg-1" +
                (this.props.expandaction ? 1 : 2) +
                " col-1" +
                (this.props.expandaction ? 1 : 2)
              }
            >
              {this.props.datatitle && (
                <Typography
                  variant="h3"
                  mt={2}
                  style={{
                    borderBottom: "3px solid #4c38c9",
                    lineHeight: "5rem",
                  }}
                >
                  {this.props.datatitle && this.props.datatitle}
                </Typography>
              )}
            </div>
            {/*this.props.datatitle && this.props.expandaction && this.state.wWidth>799 &&
					<div className={"col-sm-1 col-lg-1 col-1 expand-btn"} id="expandOption" >
						<span class={"e-icons e-zoom-"+(this.state.expandStatus?"out":"in") }></span>
					</div>
				*/}
          </div>

          <div className="row no-padding">
            <div
              className={
                "no-padding col-sm-1" +
                (this.props.expandaction && !this.props.datatitle ? 1 : 2) +
                " col-lg-1" +
                (this.props.expandaction && !this.props.datatitle ? 1 : 2) +
                " col-1" +
                (this.props.expandaction && !this.props.datatitle ? 1 : 2)
              }
            >
              {this.props.datasubtitle && (
                <Typography
                  variant="h5"
                  style={{ borderBottom: "1px solid #acacac" }}
                  mt={this.props.datatitle ? 1 : 0}
                  mb={1}
                >
                  {this.props.datasubtitle}
                </Typography>
              )}
            </div>
            {/*this.props.expandaction && !this.props.datatitle && this.state.wWidth>799 &&
					<div className={"col-sm-1 col-lg-1 col-1 expand-btn"} id="expandOption" >					 
						<span class={"e-icons e-zoom-"+(this.state.expandStatus?"out":"in") }></span>
					</div>
  				*/}
          </div>
          <div className="validation_wrapper">
            <div
              className={
                "control_wrapper" + (this.props.datatitle ? " mt-2" : "")
              }
              id="formContainer"
            >
              <div className="row no-padding">
                {this.state.formInputs ? this.state.formInputs : "NO_DATA"}

                {/**
						<MultiSelectComponent  ref={(scope) => { specialComponents[name] = scope; }} 
							dataSource={values}
							fields={checkFields} 
							placeholder={label} 
							mode="CheckBox" 
							showSelectAll={true}
							value={null}
							showDropDownIcon={true} 
							enableSelectionOrder={true}
							

							onChange={({  value }) => {  onChange({target:{ name, value} }) } }
							filterBarPlaceholder={label} popupHeight="350px">
							<Inject services={[CheckBoxSelection]} />
						</MultiSelectComponent>
						 */}
              </div>
            </div>
          </div>
        </div>

        <div className="row no-padding">{this.state.formButtons}</div>
        <DialogComponent
          id="editFieldDialog"
          animationSettings={this.animationSettings}
          header="Api response"
          ref={(dialog) => (dialogInstanceMessage = dialog)}
          visible={false}
          width="40%"
          isModal={true}
          showCloseIcon={true}
        >
          <div className="my-30">{this.state.apiResponseMessage}</div>
        </DialogComponent>
      </>
    );
  }
}
export default GenericForm;
